// components/ProblemCard.jsx — attempts display removed

import React, { useState } from "react";
import DiffPip from "./atoms/DiffPip";
import { TopicBadge, TagBadge } from "./atoms/Badges";
import FirmChip from "./atoms/FirmChip";
import { useTheme } from "../context/ThemeContext";

export default function ProblemCard({ p, onClick }) {
  const { t } = useTheme();
  const [hov, setHov] = useState(false);
  return (
    <article
      onClick={() => onClick(p)}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        background: hov ? t.bgHov : t.cardBg,
        border: `0.5px solid ${hov ? t.border2 : t.border}`,
        borderRadius: 14, padding: "22px 26px", cursor: "pointer",
        transition: "all 0.2s", transform: hov ? "translateY(-1px)" : "translateY(0)",
      }}
    >
      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 14, marginBottom: 10 }}>
        <div style={{ flex: 1 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 7, flexWrap: "wrap" }}>
            <span style={{ fontSize: 10, color: t.text3, fontFamily: "monospace", letterSpacing: "0.06em" }}>{p.id || p.problemId}</span>
            <DiffPip level={p.difficulty} />
            <TopicBadge label={p.topic} />
          </div>
          <h3 style={{ fontSize: 15, fontWeight: 600, color: t.text, margin: 0, lineHeight: 1.35, fontFamily: "'Playfair Display',Georgia,serif", letterSpacing: "-0.01em" }}>
            <a
              href={`/problem/${encodeURIComponent(p.id || p.problemId)}`}
              onClick={(e) => { e.preventDefault(); onClick(p); }}
              style={{ color: "inherit", textDecoration: "none" }}
            >
              {p.title}
            </a>
          </h3>
        </div>
        {!p.solutionRevealed && (
          <svg width="13" height="13" viewBox="0 0 14 14" fill="none" style={{ flexShrink: 0, marginTop: 4, opacity: 0.35 }}>
            <rect x="2" y="6" width="10" height="7" rx="1.5" fill={t.text2} />
            <path d="M4.5 6V5a2.5 2.5 0 0 1 5 0v1" stroke={t.text2} strokeWidth="1.2" fill="none" strokeLinecap="round" />
          </svg>
        )}
      </div>
      <p style={{ fontSize: 13, color: t.text2, lineHeight: 1.6, margin: "0 0 13px", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
        {p.preview}
      </p>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
        <div style={{ display: "flex", gap: 5, flexWrap: "wrap" }}>
          {(p.tags||[]).map((tag) => <TagBadge key={tag} label={tag} />)}
        </div>
        {(p.askedIn || []).length > 0 && (
          <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
            <span style={{ fontSize: 10, color: t.text3, marginRight: 2 }}>asked in</span>
            {p.askedIn.map((f) => <FirmChip key={f} name={f} />)}
          </div>
        )}
      </div>
      {/* Date only — no attempts */}
      <div style={{ marginTop: 12, paddingTop: 11, borderTop: `0.5px solid ${t.border}` }}>
        <span style={{ fontSize: 11, color: t.text3 }}>{new Date(p.dateAdded).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" })}</span>
        {p.addedBy?.username && <span style={{ fontSize: 11, color: t.text3, marginLeft: 10 }}>· added by {p.addedBy.username}</span>}
      </div>
    </article>
  );
}
